import { InfoCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React, { useContext } from 'react';

import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import './FormLineLayout.scss';

type FormLineLayoutProps = {
  label?: string | React.ReactNode;
  description?: string | React.ReactNode;
  isRequired?: boolean;
  children: React.ReactNode;
  rightClassName?: string;
  isOptional?: boolean;
  labelOnTop?: boolean;
  hideDescriptionIcon?: boolean;
  disabled?: boolean;
  isInModal?: boolean;
};

export const FormLineLayout: React.FC<FormLineLayoutProps> = ({
  label,
  description,
  isRequired = false,
  children,
  rightClassName,
  isOptional = false,
  labelOnTop = false,
  hideDescriptionIcon = false,
  disabled = false,
  isInModal = false,
}) => {
  const { isEditMode } = useContext(ViewEditModeContext);

  return (
    <div className={classNames('form-line-layout', { modalCenter: isInModal })}>
      <div className="form-line-layout-inner">
        <div
          className={classNames(['left-part', { 'label-on-top': labelOnTop }])}
        >
          {isRequired && isEditMode && <span className="required">*</span>}
          {label}
          {isOptional && <span className="optional">(optional)</span>}
        </div>
        <div
          className={classNames(['right-part', rightClassName, { disabled }])}
        >
          {children}
        </div>
      </div>
      {description && isEditMode && (
        <div className="form-line-layout-description">
          {!hideDescriptionIcon && <InfoCircleOutlined />}
          {description}
        </div>
      )}
    </div>
  );
};
